import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  state: {
    activityTypeItems: [],
  },
  getters: {
    activityTypeItems (state) {
      return state.activityTypeItems
    },
    uploadUrl: (state) => {
      return `${config.serverURI}/activityGenStaffs/upload`
    }
  },
  mutations: {
    SET_ACTIVITY_TYPE_ITEMS (state, payload) {
      state.activityTypeItems = payload
    }
  },
  actions: {
    loadActivityTypeItems ({ commit, dispatch }, payload) {
      console.log('-> loadActivityTypeItems')
      // return Vue.axios.get(`${config.serverURI}/activityTypes`)
      Vue.axios.get(`${config.serverURI}/activityTypes`).then((response) => {
        console.log('data', response.data)
        commit('SET_ACTIVITY_TYPE_ITEMS', response.data)
      }).catch((error) => {
        console.log('loadActivityTypeItems', error)
      })
    },
  	loadItems ({ commit, dispatch }, payload) {
      console.log('-> loadItems')
      return Vue.axios.get(`${config.serverURI}/activityGenStaffs`)
    },
    loadItemsAsPage ({ commit, dispatch }, pagination) {
      console.log('-> loadItemsAsPage', pagination)
      return Vue.axios.get(`${config.serverURI}/activityGenStaffs/page`, { params: pagination })
    },
    create ({ commit, dispatch }, payload) {
      console.log('-> create', payload)
      return Vue.axios.post(`${config.serverURI}/activityGenStaffs`, payload)
    },
    update ({ commit, dispatch }, payload) {
      console.log('-> update', payload)
      return Vue.axios.put(`${config.serverURI}/activityGenStaffs/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      console.log('delete', payload)
      return Vue.axios.delete(`${config.serverURI}/activityGenStaffs/${payload.id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/activityGenStaff.js